import { Alert, Box, Container } from "@mui/material";
import React, { useCallback } from "react";
import BackBtn from "../../widgets/BackBtn";
import useApiEp from "../../hooks/useApiEp";
import TopTitleActions from "../../widgets/TopTitleActions";
import AddIcon from "@mui/icons-material/Add";
import DataTable from "../../widgets/DataTable";
import { useNavigate, useParams } from "react-router-dom";
import MuPb from "../../widgets/MuPb";
import { getErrorResponse } from "../../utils/util";

const ProjectsList = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data, isLoading, isError, error } = useApiEp(
    `/partner/business-projects/${id}`
  );
  const handleAction = useCallback((action, id) => {
    switch (action) {
      case "view":
        navigate(`/home/${id}/business-detail`);
        break;
      case "edit":
        navigate(`/home/${id}/edit-business`);
        break;
      default:
        console.warn("unknown action", id);
    }
  }, []);
  if (isLoading) {
    return <MuPb />;
  }

  return (
    <Container sx={{ mt: 3 }}>
      <BackBtn />
      <TopTitleActions
        title={"Projects List"}
        actions={[
          {
            icon: <AddIcon />,
            label: "Add Project",
            action: () => {
              navigate(`/home/${id}/create-project`);
            },
          },
        ]}
      />
      <DataTable
        sx={{ mb: 1 }}
        columns={[
          {
            id: "serial",
            label: "S.No.",
            render: (_v, _row, idx) => idx + 1,
          },
          { id: "name", label: "Name" },
          { id: "id", label: "Project Id" },
          { id: "wa_number", label: "WA Number" },
          { id: "credit", label: "Credit" },
          {
            id: "created_at",
            label: "Created On",
            render: (v) =>
              new Date(v).toLocaleString("en-IN", {
                dateStyle: "medium",
              }),
          },
        ]}
        actions={[]}
        rows={data?.projects || []}
        page={1}
        limit={100}
        totalPages={1}
        onPageChange={null}
        onAction={handleAction}
      />
    </Container>
  );
};

export default ProjectsList;
